import { render } from "./NewRole.vue?vue&type=template&id=e7ac83e6"
import script from "./NewRole.vue?vue&type=script&lang=js"
export * from "./NewRole.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\oaromasodun\\Desktop\\MarinePortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__